import { ReactComponent as PasswordSVG } from '@/asset/svg/password.svg'
import { ReactComponent as VisibilityOffSVG } from '@/asset/svg/visibility_off.svg'
import { ReactComponent as VisibilityOnSVG } from '@/asset/svg/visibility_on.svg'
import Input from '@/component/Input'
import type { InputProps, InputRef } from 'rc-input'
import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'

const PasswordInput: React.FC<InputProps & React.RefAttributes<InputRef>> = ({ ...rest }) => {
  const { t } = useTranslation('uc')
  const [passwordVisible, setPasswordVisible] = useState(false)

  const handlePasswordInputAddonClick = () => {
    setPasswordVisible(!passwordVisible)
  }

  const prefix = (
    <span className={`flex items-center justify-center`}>
      <PasswordSVG className="w-6 fill-fontcolor-500" />
    </span>
  )

  const subfix = (
    <button
      type="button"
      tabIndex={-1}
      className={`flex items-center justify-center`}
      onClick={handlePasswordInputAddonClick}
    >
      {passwordVisible ? (
        <VisibilityOnSVG className="w-6 fill-fontcolor-400" />
      ) : (
        <VisibilityOffSVG className="w-6 fill-fontcolor-400" />
      )}
    </button>
  )

  return (
    <Input
      placeholder={t('placeholder.password')}
      {...rest}
      autoComplete="new-password"
      type={passwordVisible ? 'text' : 'password'}
      allowClear={true}
      prefix={prefix}
      suffix={subfix}
    />
  )
}

export default PasswordInput
